import ProductElement from './ProductElement'

export default ProductElement
